<template>
  <section class="empty">
    Sorry, no entity here...
    <slot/>
  </section>
</template>

<script>

export default {
  name: 'empty-base'
}

</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/layouts/empty-layout.vue